import { render, staticRenderFns } from "./PriceFinder.vue?vue&type=template&id=4baba65a&"
import script from "./PriceFinder.vue?vue&type=script&lang=js&"
export * from "./PriceFinder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports